<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row">
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="directorName" displayName="Director name">
                <label for="directorName"><h3>Director/Owner Name:</h3></label>
                <input class="form-control"
                       formControlName="directorName"
                       id="directorName"
                       placeholder=""
                       type="text"/>
            </validation>
        </div>

        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="directorSurname" displayName="Director surname">
                <label for="directorSurname"><h3>Director/Owner Surname:</h3></label>
                <input class="form-control"
                       formControlName="directorSurname"
                       id="directorSurname"
                       placeholder=""
                       type="text"/>
            </validation>
        </div>
    </div>

    <div class="row">
        <div [hidden]="!isJuristicMerchant" class="form-group col-md-6">
            <validation [formGroup]="form" controlName="registrationNumber" displayName="Business registration number">
                <label for="business-registration-number"><h3>Business Registration Number:</h3></label> <i
                    class="pi pi-question-circle tooltip-icon"
                    pTooltip="{{getRegistrationNumberTooltip()}}"></i> <input
                    normaliseRegistrationNumber
                    class="form-control"
                    formControlName="registrationNumber"
                    id="business-registration-number"
                    placeholder=""
                    type="text"/>
            </validation>
        </div>

        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="directorIdNumber" displayName="Director ID number">
                <label for="directorIdNumber"><h3>Director/Owner ID Number:</h3></label>
                <input class="form-control"
                       formControlName="directorIdNumber"
                       id="directorIdNumber"
                       type="text"/>
            </validation>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="fspNumber" displayName="FSP number">
                <label for="fspNumber"><h3>FSP Number:</h3></label> <i class="pi pi-question-circle tooltip-icon"
                                                                      pTooltip="Financial service provider number. This field is mandatory if your company is a registered financial services provider."></i>
                <input class="form-control" formControlName="fspNumber" id="fspNumber" mask="0*" type="text"/>
            </validation>
        </div>
    </div>

    @if (captureNatureOfBusiness) {
        <div class="row">
            <div class="form-group col-md-6">
                <validation [formGroup]="form" controlName="natureOfBusiness" displayName="Nature of business">
                    <label for="nature-of-business"><h3>Nature of Business:</h3></label>
                    <p-select [options]="natureOfBusinessList"
                              class="form-control"
                              formControlName="natureOfBusiness"
                              id="nature-of-business"
                              optionLabel="name"
                              optionValue="name"
                              placeholder="-- Please select --"/>
                </validation>
            </div>

            @if (otherNatureOfBusinessSelected) {
                <div class="form-group col-md-6">
                    <validation [formGroup]="form" controlName="natureOfBusinessOther"
                                displayName="Nature of business">
                        <label for="natureOfBusinessOther"><h3>Please specify (nature of business):</h3></label>
                        <input class="form-control"
                               formControlName="natureOfBusinessOther"
                               id="natureOfBusinessOther"
                               placeholder=""
                               type="text"/>
                    </validation>
                </div>
            }
        </div>
    }

    <div class="row">
        <div class="form-group col-md-12">
            <validation [formGroup]="form" controlName="websiteUrl" displayName="Website URL">
                <label for="websiteUrl"><h3>Website URL:</h3></label>
                <input class="form-control"
                       formControlName="websiteUrl"
                       id="websiteUrl"
                       pTooltip="Website URL for the business"
                       type="text"/>
            </validation>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-12">
            <validation [formGroup]="form" controlName="overview" displayName="Business overview">
                <label for="overview"><h3>Tell us what your business does:</h3></label>
                <textarea class="form-control"
                          cols="2"
                          formControlName="overview"
                          id="overview"
                          pTooltip="Business overview (i.e detailed business overview and related information)"
                          rows="4"
                          type="text"></textarea>
            </validation>
        </div>
    </div>

    <div class="row justify-content-center justify-content-sm-center">
        <div class="btn-group mt-5">
            <button (click)="emitGoToPrevious()" class="navy-btn mr-3" type="button">
                <i class="fa fa-chevron-left fas"></i> &nbsp;Back
            </button>
            <button class="navy-btn" type="submit">Next <i class="fa fa-chevron-right fas"></i>
            </button>
        </div>
    </div>

</form>
<pre [hidden]="!isDeveloperMode()"><code>{{ getAllErrors(form) | json }}</code></pre>
